import React, { useMemo } from 'react';
import { useAvailableCareLinesForUserQuery } from '../../../graphQL';
import { CareTypeEditModal, useDrilldownContext } from '../helpers';
import { Styles, Text } from '../styles';
import { UserCareFlow } from './UserCareFlow';

export const CareFlowsSection = () => {
  const { user } = useDrilldownContext();
  const { data: organizationConfig, loading: orgConfigLoading } = useAvailableCareLinesForUserQuery(
    { variables: { userId: user.id } }
  );

  const orgCareFlows = user.organization?.careFlows;

  const availableOptions = useMemo(() => {
    if (orgConfigLoading || !organizationConfig) return [];
    return organizationConfig.providerDashboardAvailableCareLinesForUser.availableOptions;
  }, [orgConfigLoading, organizationConfig]);

  return (
    <Styles.sidebarSection>
      <Styles.sidebarSectionHeader>
        <Text.h3>Care Types</Text.h3>
        <CareTypeEditModal text="Add/Edit" />
      </Styles.sidebarSectionHeader>
      <Styles.spaceBetween>
        <div>
          <Text.label>CURRENT {user.careFlows.length === 1 ? 'PLAN' : 'PLANS'}</Text.label>
          {user.careFlows.map(flow => {
            const orgCareFlow = orgCareFlows?.find(orgFlow => orgFlow.careType === flow.careType);
            return <UserCareFlow key={flow.careType} careFlow={flow} orgCareFlow={orgCareFlow} />;
          })}
          {user.careFlows.length === 0 && <Text.body className="mt3">None</Text.body>}
          <Text.label>AVAILABLE</Text.label>
          {availableOptions.map(option => {
            return (
              <Styles.PlanContainer>
                <Text.bodyBold>{option.serviceTitle}</Text.bodyBold>
                <Text.body>{option.serviceOptionsCopy}</Text.body>
              </Styles.PlanContainer>
            );
          })}
        </div>
      </Styles.spaceBetween>
    </Styles.sidebarSection>
  );
};
